import {register} from '@shopify/theme-sections'
import '../../styles/sections/index-image-content.scss'

export default register(`index-image-content`, {
    onload() {
    },
    onUnload() {
    }
})